import React from "react";
import LoadingUI from "components/common/LoadingUI";
import ModalWrapper from "components/common/ModalWrapper";
import OptVsDetectorCompareChart from "./OptVsDetectorCompareChart";
import { CstAPI } from "apis";
import {
  useAnatomyFilter,
  useAnatomyData,
  useAnatomyUI,
} from "./context/AnatomyContexts";

class OptVsDetectorModalInner extends React.PureComponent {
  constructor(props) {
    super(props);

    const { detailChartProps } = props;

    this.state = {
      groupType: detailChartProps.groupType,
      layerNum: detailChartProps.layerNum,
      metric: detailChartProps.metric,

      confidenceReports: null,
      errMsg: null,
      isLoading: false,
    };
  }

  async componentDidMount() {
    const { unitInfo, segmentId } = this.props;
    const { networkId, gamUnitId } = unitInfo;
    this.setState({ isLoading: true });
    try {
      const params = {
        networkId,
        unitId: gamUnitId,
        uprSegmentId: segmentId,
      };
      const r = await CstAPI.getGodviewConfidenceReport(params);
      this.setState({ confidenceReports: r, errMsg: null, isLoading: false });
    } catch (err) {
      console.log(err);
      this.setState({ errMsg: err.toString(), isLoading: false });
    }
  }

  render() {
    const {
      isOpenViewModal,
      handleClose,
      unitInfo,
      data,
      getFilterParams,
      segmentId,
      detailChartProps,
      timezoneType,
    } = this.props;
    const {
      groupType,
      layerNum,
      metric,
      errMsg,
      confidenceReports,
      isLoading,
    } = this.state;

    return (
      <ModalWrapper
        isOpen={isOpenViewModal}
        showCloseFooter={true}
        handleClose={handleClose}
        title="O vs O's Shadow vs Godview"
      >
        <div className="overflow-y-auto" style={{ maxHeight: "600px" }}>
          <div>
            {errMsg && <div className="text-red-600">{errMsg}</div>}
            {isLoading && <LoadingUI></LoadingUI>}
          </div>

          {confidenceReports && (
            <OptVsDetectorCompareChart
              unitInfo={unitInfo}
              data={data}
              confidenceReports={confidenceReports}
              segmentId={segmentId}
              getFilterParams={getFilterParams}
              detailChartProps={detailChartProps}
              groupType={groupType}
              layerNum={layerNum}
              metric={metric}
              timezoneType={timezoneType}
            ></OptVsDetectorCompareChart>
          )}
        </div>
      </ModalWrapper>
    );
  }
}

const OptVsDetectorModal = React.memo((props) => {
  const filterContext = useAnatomyFilter();
  const dataContext = useAnatomyData();
  const uiContext = useAnatomyUI();

  if (!filterContext || !dataContext || !uiContext) {
    return <OptVsDetectorModalInner {...props} />;
  }

  return (
    <OptVsDetectorModalInner
      {...props}
      isOpenViewModal={uiContext.isOptVsDetectorModalOpen}
      timezoneType={filterContext.timezoneType}
      handleClose={uiContext.handleCloseModal}
      detailChartProps={uiContext.detailChartProps}
      unitInfo={dataContext.unitInfo}
      segmentId={dataContext.selectedUprSegmentId}
      data={dataContext.reports}
      getFilterParams={filterContext.getFilterParams}
    />
  );
});

export default OptVsDetectorModal;
